import { Notifications } from 'app/notifications/Notifications';
import { AppRoutes } from 'routing/AppRoutes';

export const App = () => (
  <>
    <AppRoutes />
    <Notifications />
  </>
);
